import React, { useState, useEffect, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import WpAPI from '../../WpApi';
import PageLoader from './PageLoader';

const Splash = (props) => {
    const { store } = useContext(ReactReduxContext);
    const [splash, setSplash] = useState(false);
    const [loader, setLoader] = useState(false);
    const [account, setAccount] = useState(null);
    
    const handleCloseEvent = () => {
        localStorage.setItem('show_splash', true);
        setSplash(false);
    }
    
    // useEffect(() => {
    //     if(WpAPI.isLoggedIn()){
    //         let isSplashClicked = localStorage.getItem('show_splash');
    //         WpAPI.fetchAccountInfo().then(({plan}) => {
    //             if(!plan){
    //                 setSplash(false);
    //             }else if(plan.id == 0 && isSplashClicked == null){
    //                 setLoader(true);
    //                 setTimeout(function(){
    //                     setSplash(true);
    //                     setLoader(false);
    //                 }, 300)
    //             }else{
    //                 setSplash(false);
    //             }
    //         }).catch((e) => {
    //             console.log(e)
    //         })
    //     }
    // }, [])

    
    // if(WpAPI.isLoggedIn() && loader){
    //     return (<>
    //         <div className={`container no-print`}>
    //             <div className={`splash-msg`} style={{backgroundColor: "#FFF"}}>
    //                 <PageLoader />
    //             </div>
    //         </div>
    //     </>);
    // }
    
    // return (<>
    //     {splash ? <div className={`container no-print`}>
    //         <div className={`splash-msg${props.hasOwnProperty('cssClass') ? ' ' + props.cssClass : ''}`}>
    //             <div className="close-it" onClick={() => {
    //                 handleCloseEvent()
    //             }}><i>Close</i></div>
    //             {/* <p>Available now until June 20, 2023: Experience the beta version of our Resume Builder app with all premium features unlocked for FREE! For the next two weeks, explore the full power of our advanced tools to create standout resumes.</p> */}
    //             {/* <p>We Are Officially Out of Beta! As a token of our appreciation, all existing users get a free 30-Day Access - Beta User Appreciation Reward. Enjoy full access to all features from 6/20/2023 to 7/20/2023.</p> */}
    //             <p>Available now until July 20, 2023, experience the beta version of our Resume Builder app including all premium features for FREE! Explore the full power of our advanced tools to create standout resumes.</p>
    //         </div >
    //     </div > : ''}
    // </>);

    return null;
}

export default Splash;